<template>
  <v-dialog v-model="dialog" max-width="500">
    <v-card v-if="usuario" class="pa-4">
      <v-card-title class="font-weight-bold" style="font-size: 18px; display: flex; justify-content: space-between; align-items: center;">
        Datos del Cliente
        <v-btn icon small @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="text-center">

        <!-- FOTO -->
        <v-avatar size="120" class="elevation-4 mb-4" v-if="usuario.principal && usuario.principal.linkPhoto">
          <img
            :src="serverUrl + 'api/principal/get_image/' + usuario.principal.identificador + '/' + usuario.principal.linkPhoto"
            :style="{
              height: '120px',
              transform: 'scale(' + ((usuario.principal.zoom || 50) / 50) + ') translate(' + (usuario.principal.fotox || 0) + 'px,' + (usuario.principal.fotoy || 0) + 'px)',
            }"
          />
        </v-avatar>

        <v-avatar size="120" class="elevation-4 mb-4" color="grey lighten-2" v-else>
          <v-icon size="60" color="grey">mdi-account</v-icon>
        </v-avatar>

        <!-- DATOS -->
        <div class="mt-3">
          <div class="mb-2" style="font-size: 16px;">
            <span class="font-weight-bold">Nombre:</span> {{ usuario.name }}
          </div>
          <div class="mb-2" style="font-size: 14px;">
            <span class="font-weight-bold">Identificador:</span> {{ usuario.identificador }}
          </div>
          <div class="mb-2" style="font-size: 14px;">
            <span class="font-weight-bold">Email:</span> {{ usuario.email }}
          </div>
          <div v-if="usuario.principal && usuario.principal.descripcion" class="mb-2" style="font-size: 14px;">
            <span class="font-weight-bold">Descripción:</span> {{ usuario.principal.descripcion }}
          </div>
        </div>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { http } from '@/services/config';

export default {
  name: 'UsuarioPedidoDialog',

  props: {
    value: {
      type: Boolean,
      default: false
    },
    usuario: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      serverUrl: http.defaults.baseURL
    };
  },

  computed: {
    dialog: {
      get() { return this.value; },
      set(v) { this.$emit('input', v); }
    }
  }
};
</script>
